import { combineReducers } from 'redux';
import loginReducers from './login';
import userProfileReducers from './userProfile';
import mapReducer from './map';
import lightModeReducers from './lightMode';

const rootReducer = combineReducers({
  loginReducers,
  userProfileReducers,
  lightModeReducers,
  mapReducer,
});

export default rootReducer;
